import { motion } from "framer-motion";

const ContactHero = () => {
  return (
    <section className="bg-gray-50 py-16 sm:py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl text-left"
        >

          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 leading-tight">
            Contact
            <span className="text-green-600 ml-2">
              AfyaEquip
            </span>
          </h1>

          <p className="mt-5 max-w-xl text-gray-600 text-base sm:text-lg leading-relaxed">
            Have questions about our healthcare equipment? Our team is ready to help you find the right solution.
          </p>

        </motion.div>

      </div>
    </section>
  );
};

export default ContactHero;